var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCube(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "215.9mm",
    height: "215.9mm",
    viewBox: "0 0 2550 2550",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    baseProfile: "tiny",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "black",
    strokeWidth: 1,
    fillRule: "evenodd",
    strokeLinecap: "square",
    strokeLinejoin: "bevel"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillOpacity: 0,
    stroke: "none",
    transform: "matrix(1,0,0,1,0,0)",
    fontFamily: "Arial",
    fontSize: 12,
    fontWeight: 400,
    fontStyle: "normal"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2550,
    height: 2550
  })), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#000000",
    strokeOpacity: 0,
    strokeWidth: 0,
    strokeLinecap: "square",
    strokeLinejoin: "bevel",
    transform: "matrix(1,0,0,1,0,0)",
    fontFamily: "Arial",
    fontSize: 12,
    fontWeight: 400,
    fontStyle: "normal"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1,
    stroke: "#000000",
    strokeOpacity: 1,
    strokeWidth: 150,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 2,
    transform: "matrix(1,0,0,1,0,0)",
    fontFamily: "Arial",
    fontSize: 12,
    fontWeight: 400,
    fontStyle: "normal"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1,
    stroke: "#000000",
    strokeOpacity: 1,
    strokeWidth: 150,
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    transform: "matrix(1,0,0,1,0,0)",
    fontFamily: "Arial",
    fontSize: 12,
    fontWeight: 400,
    fontStyle: "normal"
  }, /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    vectorEffect: "none",
    points: "1138.48,2470.46 2156.98,1882.43 "
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    vectorEffect: "none",
    points: "1138.48,2470.46 1138.48,1294.4 "
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    vectorEffect: "none",
    points: "1138.48,1294.4 2156.98,706.377 "
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    vectorEffect: "none",
    points: "2156.98,1882.43 2156.98,706.377 "
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    vectorEffect: "none",
    points: "119.989,1882.43 119.989,706.377 "
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    vectorEffect: "none",
    points: "1138.48,1294.4 119.989,706.377 "
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    vectorEffect: "none",
    points: "1138.48,2470.46 119.989,1882.43 "
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    vectorEffect: "none",
    points: "119.989,706.377 1138.48,118.349 "
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    vectorEffect: "none",
    points: "2156.98,706.377 1138.48,118.349 "
  })), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeWidth: 150,
    strokeLinecap: "square",
    strokeLinejoin: "bevel",
    transform: "matrix(1,0,0,1,0,0)",
    fontFamily: "Arial",
    fontSize: 12,
    fontWeight: 400,
    fontStyle: "normal"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCube);
export default __webpack_public_path__ + "static/media/cube.9db874bd2fa9b5b324b5a43c2e1d8e75.svg";
export { ForwardRef as ReactComponent };